import { usePopupContext } from "~components/Popup/PopupProvider"
import { popupBridge } from "~components/Popup/popup-bridge"

export const usePopup = () => {
  const ctx = usePopupContext()
  if (ctx) return ctx

  const bridge = popupBridge.get()
  if (bridge) return bridge

  throw new Error("PopupProvider not found")
}
